import ElProgress from './src/progress';

export default ElProgress;



// WEBPACK FOOTER //
// ./src/components/QnUpload-1.0.0/progress/index.js